import React from 'react';

import { ArticleContent } from '.';
import Feed from '../Feed';

interface SearchArticlesListProps {
  content: ArticleContent;
}

const SearchArticlesList = ({ content }: SearchArticlesListProps) => {
  return (
    <Feed
      articlesOrBriefings={content.articles}
      articleData={content.contentData}
      commentCounts={content.commentCounts}
      useLargeImage
    />
  );
};

export default SearchArticlesList;
